import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-stethoscope-icon',
	templateUrl: './stethoscope-icon.component.html',
})
export class StethoscopeIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
